// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-templates-cms-route-tsx" + "-" + "c60078f1d80d6040f86f" + ".js";
};